import { parse } from 'date-fns';
import { DATE_TIME_FORMAT } from '../../../../constants';
import { ReportSettingRollforwardState } from '../Rollforward';

export const getReportEndDateRollforward = (
  reportSettingState: ReportSettingRollforwardState,
): Date => {
  const { rollforwardThrough } = reportSettingState;
  return parse(rollforwardThrough, DATE_TIME_FORMAT.FULL_DATE, new Date());
};
